let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("36tiz")).then(() => parcelRequire('kbi7L'));